import $ from 'jquery';

// eslint-disable-next-line max-len
const closeText = '<svg width="13" height="13" xmlns="http://www.w3.org/2000/svg"><g transform="translate(.485 .485)" fill="#FFF" fill-rule="evenodd"><rect y="5" width="12" height="2" rx="1"/><rect transform="rotate(90 6 6)" y="5" width="12" height="2" rx="1"/></g></svg>';
$( 'a[href^="#mdl-"]' ).click( function() {
	$( this ).modal( {
		fadeDuration: 250,
		fadeDelay: 0,
		closeText,
	} );
	return false;
} );
